export default __webpack_public_path__ + "static/system-f037ae2633c0c80e3ac977c526cb3a39.png";